module.exports = __webpack_public_path__ + "img/add.aee96643.png";